const trackShare = (platform: any, trackingId: string) => () => {
    // todo: add plausible event tracking
}

export default trackShare
